import React from 'react'
import { PopoverBody as ReactStrapPopoverBody, PopoverBodyProps as ReactStrapPopoverBodyProps } from 'reactstrap'

export const PopoverBody = (props: ReactStrapPopoverBodyProps) => <ReactStrapPopoverBody {...props} />
